import { Button, HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import LabelText from 'components/text/LabelText';

import useTranslation from 'pages/ApplicationDetailsPage/hooks/useTranslation';

import {
    CHEVRON_CHARACTER,
    COORDINATE_DECIMAL_PLACES,
    PICK_BUTTON_TEST_ID,
    TEST_ID
} from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const HomePointControl: FunctionComponent<Props> = ({
    className = '',
    homePoint,
    isDisabled,
    isPicking,
    onPickHomePoint,
    testId = TEST_ID
}) => {
    const { HOME_POINT_CANCEL_PICK_BUTTON, HOME_POINT_LABEL, HOME_POINT_PICK_BUTTON } =
        useTranslation();

    const coordinateText = homePoint
        ? `${homePoint.lat.toFixed(COORDINATE_DECIMAL_PLACES)}, ${homePoint.lon.toFixed(COORDINATE_DECIMAL_PLACES)}`
        : HOME_POINT_PICK_BUTTON;
    const buttonText = isPicking ? HOME_POINT_CANCEL_PICK_BUTTON : coordinateText;

    return (
        <VerticalContainer className={`${className} ${styles.homePointControl}`} testId={testId}>
            <LabelText text={HOME_POINT_LABEL} />

            <Button
                className={styles.pickerButton}
                isDisabled={isDisabled}
                onClick={onPickHomePoint}
                testId={PICK_BUTTON_TEST_ID}>
                <HorizontalContainer className={styles.pickerRow}>
                    <Wrapper className={styles.pin} />

                    <Wrapper className={styles.label}>{buttonText}</Wrapper>

                    <Wrapper className={styles.chevron}>{CHEVRON_CHARACTER}</Wrapper>
                </HorizontalContainer>
            </Button>
        </VerticalContainer>
    );
};

export default HomePointControl;
